import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '@bayclubs/utils';

import { GroupClassesSecurityService } from './group-classes-security.service';

@Injectable({
    providedIn: 'root'
})
export class GcNavigationService {
    constructor(
        private security: GroupClassesSecurityService,
        private router: Router,
        private sessionService: SessionService
    ) {}

    public goToLogin(returnToUrl?: string) {
        if (returnToUrl && this.isValidReturnUrl(returnToUrl)) {
            this.sessionService.setItem('returnUrl', returnToUrl);
        }

        this.router.navigate(['/login']);
    }

    public isValidReturnUrl(returnToUrl: string) {
        return returnToUrl && returnToUrl.length > 0 && returnToUrl !== '/';
    }

    public goTo403() {
        this.router.navigate(['/forbidden']);
    }

    public goTo404() {
        this.router.navigate(['/not_found']);
    }

    public goToClubsConfiguration() {
        this.router.navigate(['/configuration/']);
    }

    public goToClubConfiguration(clubId: string) {
        this.router.navigate(['/configuration/' + clubId]);
    }
}
